module.exports = __webpack_public_path__ + "img/f3.e82a79e0.png";